@if (advisor) {
  <div>
    <section id="introArticleDetails" [ngStyle]="{'background-image': 'url('+advisor.imageUrl+')'}">
      <div class="half-black">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="display-4" >{{advisor.title}}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="mainArticle">
      <main role="main" class="container">
        <div class="row">
          <aside class="col-md-4 blog-sidebar">
            <img class="card-img-right flex-auto d-md-block img-fluid" src="{{advisor.imageUrl}}" width="100%"
              alt="">
              <div class="p-3 mb-3 bg-light rounded">
                <h3>{{advisor.fullName}}</h3>
                <p class="mb-2"><strong>Toll Free:</strong><a href="tel:{{advisor.phones['Toll Free']}}"> {{advisor.phones['Toll Free']}}</a></p>
                @if (advisor.phones.Local) {
                  <p class="mb-2"><strong>Local:</strong> <a href="tel:{{advisor.phones.Local}}"> {{advisor.phones.Local}}</a></p>
                }
                <p class="mb-2"><strong>Cell:</strong> <a href="tel:{{advisor.phones.Cell}}"> {{advisor.phones.Cell}}</a></p>
                @if (advisor.phones.Fax) {
                  <p class="mb-2"><strong>Fax:</strong> <a href="tel:{{advisor.phones.Fax}}"> {{advisor.phones.Fax}}</a></p>
                }
                <p class="mb-2"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x"></fa-icon></i> <a href="mailto:{{advisor.email}}"> {{advisor.email}}</a></p>
                <p class="mb-2"><i class="fas fa-id-card"></i><fa-icon [icon]="faIdCard" size="1x"></fa-icon> <a href="{{advisor.vCardUrl}}"> Download Business vCard</a></p>
              </div>
              <div class="p-3 social-icons">
                <h3>Share</h3>
                <ul class="">
                  <li (click)="socialsharefacebook()" class="social-share facebook"><i><app-facebook></app-facebook></i></li>
                  <li (click)="socialsharetwitter()" class="social-share twitter"><i><app-twitter></app-twitter></i></li>
                  <li (click)="socialsharelinkedin()" class="social-share linkedin"><i><app-linkedin></app-linkedin></i></li>
                  <li (click)="emailCurrentPage()" class="social-share email"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x"></fa-icon></i></li>
                </ul>
              </div>
              <!-- <div *ngIf="clientServices">
              <img class="card-img-right flex-auto d-md-block img-fluid" src="{{clientServices.imageUrl}}" width="100%"
                alt="">
                <div class="p-3 mb-3 bg-light rounded">
                  <h3>{{clientServices.fullName}}</h3>
                  <p class="mb-2"><strong>Toll Free:</strong><a href="tel:{{clientServices.phone['Toll Free']}}"> {{advisor.phones['Toll Free']}}</a></p>
                  <p class="mb-2"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x"></fa-icon></i> <a href="mailto:{{clientServices.email}}"> {{advisor.email}}</a></p>
                  <p class="mb-2"><i class="fas fa-id-card"></i><fa-icon [icon]="faIdCard" size="1x"></fa-icon> <a href="{{clientServices.vCardUrl}}"> Download Business vCard</a></p>
                </div>
              </div> -->
            </aside><!-- /.blog-sidebar -->
            <div class="col-md-8 blog-main">
              <div class="blog-post">
                @if (advisor) {
                  <div>
                    <!-- <div [innerHTML]="article.content | safe:'html'"></div>  -->
                    <div [innerHTML]="advisor.bio | safe:'html'"></div>
                  </div>
                }
                <!-- <div class="p-3 image50">
                <div [innerHTML]="advisor.additionalInfo | safe:'html'"></div>
              </div> -->
            </div><!-- /.blog-post -->
          </div><!-- /.blog-main -->
        </div><!-- /.row -->
      </main>
    </section>

    <section *ngIf="advisor.team!=null && advisor.team.length>0">
      <div class="container" [ngClass]="">
        <div class="row">
          <div class="col"><h2 class="font-bree" style="font-size:2em; border-bottom:1px solid #ccc;">{{advisor.first}}'s Team:</h2></div>
          <div class=" d-flex justify-content-center flex-wrap align-content-center" [ngClass]="" >
            <div *ngFor="let a of advisor.team" class="my-3 mx-3 px-3 flex-fill" style="max-width:265px" [ngStyle]="" >
              <h3 class="team-member-description">{{a.description}}<span *ngFor="let d of a.designations; let isLast = last;let isFirst = first" [title]="d.description"><ng-container *ngIf="isFirst">,</ng-container> {{d.designation}}<ng-container *ngIf="!isLast">,</ng-container></span></h3>
              <a *ngIf="a.friendlyUrl;else reg1" [href]="a.friendlyUrl"><img loading="lazy" class="img-fluid img-square" src="{{a.imageUrl}}" width="100%" alt="{{a.imageAltText}}"></a>
              <ng-template #reg1><img loading="lazy" class="img-fluid img-square" src="{{a.imageUrl}}" width="100%" alt="{{a.imageAltText}}"></ng-template>
              <div class="py-2 mb-3 rounded">
                <h3><strong>
                  <a *ngIf="a.friendlyUrl;else reg" [href]="a.friendlyUrl" style="text-decoration: none;">
                    {{a.name}} {{a.name_last}}<span *ngFor="let d of a.designationsAfterName; let isLast = last;let isFirst = first" [title]="d.description"><ng-container *ngIf="isFirst">,</ng-container> {{d.designation}}<ng-container *ngIf="!isLast">,</ng-container></span>
                  </a>
                  <ng-template #reg>{{a.name}} {{a.name_last}}<span *ngFor="let d of a.designationsAfterName; let isLast = last;let isFirst = first" [title]="d.description"><ng-container *ngIf="isFirst">,</ng-container> {{d.designation}}<ng-container *ngIf="!isLast">,</ng-container></span>
                  </ng-template>
                  
              
                </strong></h3>
                <!-- <p class="mb-2 small"><strong>Phone:</strong><a class="td-none" href="tel:{{clientServices.phone}}"> {{clientServices.phone}}</a></p> -->
                <!-- <p class="mb-2 small"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x" [classes]="['']"></fa-icon></i> <a class="td-none" href="mailto:{{a.email}}"> Email {{a.name}}</a></p> -->
                <p class="mb-2 small" *ngIf="a.keywords && a.friendlyUrl">
                  <a class="td-none" href="{{a.friendlyUrl}}" target="_blank">{{a.keywords}}</a>
                </p>
                <p class="mb-2 small" *ngIf="a.keywords && a.friendlyUrl == undefined">
                  <span class="td-none" >{{a.keywords}}</span>
                </p>
                <p *ngIf="a.name_last != undefined" class="mb-2 small">                  
                  <fa-icon [icon]="faIdCard" size="1x"></fa-icon>
                  <a rel="nofollow" class="td-none" href="https://data2.ifa.com/api/v1/vcard/?name_first={{a.name}}&name_last={{a.name_last}}" download="{{a.name}}-{{a.name_last}}.vcf"> Download Business vCard</a>
                </p>
                <p *ngIf="a.additionalInfo != undefined && a.additionalInfo.length > 0" class="mb-2 small">
                  
                  <a rel="nofollow" class="mx-2 td-none" href="{{a.additionalInfo}}">Schedule a Meeting with {{a.name}}</a>
                </p>
              </div>
              <!-- <code>
                <pre>
{{a|json}}
                </pre>
              </code> -->
            </div> 
  
          </div>
        </div>
       
      </div>
    </section>
  </div>
}

